/** Stable correlation id per browser tab for Accounts API calls. */
export function getOrCreateCorrelationId(): string {
  if (typeof window === "undefined") {
    return "";
  }
  const key = "he_correlation_id";
  try {
    const existing = sessionStorage.getItem(key);
    if (existing?.trim()) {
      return existing.trim();
    }
    const id = crypto.randomUUID();
    sessionStorage.setItem(key, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}
